export default {"src":"/_next/static/media/example-desk.0f6d2ce2.svg","height":196,"width":431,"blurWidth":0,"blurHeight":0};